import { useContext } from 'react'
import { ModalContext } from '../ModalContext'

import ExerciseLibraryList from 'components/Exercise/ExerciseLibraryList'

export default function ExerciseLibraryModal() {
    const { modalData, HideModal } = useContext(ModalContext)

    const OnExerciseSelected = (exercise) => {
        modalData.OnExerciseSelected(exercise);
        HideModal()
    }

    return (
        <div className='space-y-4'>
            <div className='-mt-5 space-y-1'>
                <div className="text-xl text-left text-base font-semibold leading-6 text-gray-900">
                    Exercise Library
                </div>

                {modalData.subHeaderText && 
                    <p className='text-sm text-left'>{modalData.subHeaderText}</p>
                }
            </div>

            <ExerciseLibraryList OnExerciseSelected={OnExerciseSelected} />
        </div>
    )
}